// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CorePricingUtils from "../library/utils/CorePricingUtils.bs.js";

function getVM(campaigns) {
  return {
          active: CorePricingUtils.getActiveCampaign(campaigns),
          scheduled: CorePricingUtils.getScheduledCampaigns(campaigns),
          pending: CorePricingUtils.getPendingCampaigns(campaigns)
        };
}

export {
  getVM ,
  
}
/* CorePricingUtils Not a pure module */
